import React from 'react';

const HeaderSocials = () => {
  return (
    <div className='home_socials'>
        <a href="https://instagram.com/_iamrenn" className='home_social-link' target='_blank'>
            <i class='fa-brands fa-instagram'></i>
        </a>

        <a href="https://twitter.com/renn_tutorial" className='home_social-link' target='_blank'>
            <i class='fa-brands fa-twitter'></i>
        </a>

        <a href="https://behance.com" className='home_social-link' target='_blank'>
            <i class='fa-brands fa-behance'></i>
        </a>

        <a href="htpps://dribble.com" className='home_social-link' target='_blank'>
            <i class='fa-brands fa-dribble'></i>
        </a>

        <a href="" className='https://pinterest.com' target='_blank'>
            <i class='fa-brands fa-pinterest'></i>
        </a>
    </div>
  )
}

export default HeaderSocials